export default class Pagination {
   static attach() {
      $('#pagination-selector').change(function(evt) {
         evt.preventDefault();
         UrlProc.filter($(evt.target).val(), 'per');
      });
   }
}
